import { render, staticRenderFns } from "./StudentsTable.vue?vue&type=template&id=1d1d9fd1&"
import script from "./StudentsTable.vue?vue&type=script&lang=js&"
export * from "./StudentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports